<template>
  <div class="sn-table-item-actions d-flex flex-row rounded-lg">
    <div class="sn-table-item-actions--select-all d-flex flex-row">
      <!-- Select All Checkbox -->
      <v-simple-checkbox
        v-model="selected"
        v-ripple="false"
        :indeterminate="indeterminate"
        off-icon="$snCheckBox"
        on-icon="$snCheckBoxSelected"
        indeterminate-icon="$snCheckBoxIndeterminate"
        color="snBrand"
        class="sn-table-item-actions--select-all__checkbox"
        data-cy="table-header-select-all-checkbox"
      />

      <!-- Num Selected Label -->
      <div class="sn-table-item-actions--num-selected sn-subtitle-1 sn-font-weight-regular sn-text-primary-01 text-no-wrap">
        <span>{{ numSelected }} selected</span>
      </div>

      <!-- Visible/Featured Action Buttons -->
      <sn-btn
        v-for="action in shownActions"
        :key="action.id"
        class="sn-table-item-actions--item-action-btn"
        type="text"
        :text="action.text"
        :prepend-icon="action.icon"
        :icon-size="action.icon.startsWith('$') ? 24 : undefined"
        :data-cy="`table-header-${action.text}-btn`"
        :data-pendo="pendo + '-ActionHeaderAction'"
        :data-pendo-action="action.name"
        @click="emitAction(action)"
      />

      <!-- "More" Dropdown for non-visible actions -->
      <sn-btn
        v-if="moreActions"
        class="sn-table-item-actions--item-action-btn"
        type="text"
        text="More"
        dropdown
        :dropdown-options="moreActions"
        disabled-tooltip-direction="right"
        @click="emitAction($event)"
      />
    </div>
  </div>
</template>

<script>
import SnBtn from '~/components/snui/v2/snBtn/snBtn'

export default {
  name: 'ItemActionsHeader',
  components: {
    SnBtn
  },
  props: {
    indeterminate: {
      type: Boolean,
      required: true
    },
    numSelected: {
      type: Number,
      required: true
    },
    actions: {
      type: Array,
      required: true
    },
    numFeaturedActions: {
      type: Number,
      required: true
    },
    selectedItems: {
      type: Array,
      required: true
    },
    pendo: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    selected: {
      get () { return this.numSelected > 0 },
      set () { this.$emit('header-select') }
    },
    activeActions () {
      let activeActions = this.actions

      if (this.numSelected > 1) {
        activeActions = activeActions.filter(a => !a.singleItemOnly)
      }

      activeActions = activeActions.filter(a => a.conditional === undefined || (a.overrideConditionalOnHeader !== undefined && a.overrideConditionalOnHeader) || this.selectedItems.every(i => a.conditional(i)))

      return activeActions
    },
    shownActions () {
      return this.activeActions.slice(0, this.numFeaturedActions)
    },
    moreActions () {
      if (this.activeActions.length < this.numFeaturedActions + 1) return null

      return this.activeActions.slice(this.numFeaturedActions, this.activeActions.length).map(action => {
        return {
          label: action.text,
          ...action
        }
      })
    }
  },
  methods: {
    emitAction (action) {
      if (action.name) {
        this.$emit('item-action', {
          action: action.name,
          selectedItems: this.selectedItems
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.sn-table-item-actions {
  background-color: $sn-brand-01;
  max-height: 47px;
  position: absolute;
  top: 0;
  width: calc(100% - 2px);
  z-index: 1;

  &--item-action-btn {
    margin: 0 30px;
  }

  &--num-selected {
    line-height: 48px !important;
    padding-left: 12px;
    padding-right: 22px;
  }

  &--select-all {
    width: 100%;
    align-items: center;

    &__checkbox {
      min-width: 48px;
      padding: 12px;
      width: 5%;
    }
  }
}
</style>
